<template>
  <div class="index">
    <div class="information-container">
      <div class="centered">
        <button class="button save-content" @click="handleSaveRequisites()" :disabled="disabled">{{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}</button>
      </div>
      <div class="columns is-multiline requisites" v-if="requisitesData" v-model="requisitesData">
        <RequisiteItem v-for="requisite in requisitesData" :object="requisite" :key="requisite.id"/>
      </div>
      <div class="centered add-document">
        <span class="button-wrapper link" @click="handleAddRequisite">
          <a class="button is-info">+</a> Добавить реквизит
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import RequisiteItem from 'components/Information/RequisiteItem'
import { mapState, mapActions } from 'vuex'
import deepcopy from 'deepcopy'
import uuidv4 from 'uuid/v4'

export default {
  name: 'InformationDocuments',
  data () {
    return {
      disabled: false
    }
  },
  computed: {
    ...mapState(['requisites']),
    requisitesData: {
      get () {
        return deepcopy(this.requisites)
      }
    }
  },
  created () {
    this.getRequsities()
  },
  methods: {
    ...mapActions(['getRequsities', 'addRequisite', 'saveRequisites']),
    handleAddRequisite () {
      this.addRequisite({
        id: uuidv4()
      })
    },
    handleSaveRequisites () {
      this.disabled = true
      this.saveRequisites(this.requisites)
      .then(() => {
        this.disabled = false
        this.$toast.open({ message: 'Сохранено' })
      })
    }
  },
  components: { RequisiteItem }
}
</script>

<style scoped>
.information-container {
  padding: 25px 90px 60px;
  margin: 15px 0 0;
  max-width: 1368px;
  margin: 0 auto;
}
.requisites {
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// Requisites.vue?81510e7a